import Api from '@/api'

const state = {
    sensitiveList: [],
    refreshFlag: false,
    shots: [],
    shotTotal: 0,
    shotPageNo: 1,
    shotTotalPage: 0
}

const getters = {
    sensitiveList: state => state.sensitiveList,
    refreshFlag: state => state.refreshFlag,
    shots: state => state.shots,
    shotTotal: state => state.shotTotal,
    shotPageNo: state => state.shotPageNo,
    shotTotalPage: state => state.shotTotalPage
}
const mutations = {}
const actions = {
    addSensetive({state}, params) {
        return Api.addSensetive(params).then(() => {
            state.refreshFlag = true
        })

    },
    getSensetive({state}, params) {
        return Api.getSensetive(params).then(({data}) => {
            let {words} = data
            state.refreshFlag = false
            let sensitiveList = []
            for (var key in words) {
                sensitiveList.push({name: words[key]})
            }
            state.sensitiveList = sensitiveList
        })
    },
    delSensetive({commit, dispatch}, params) {
        return Api.delSensetive(params).then(() => {
            state.refreshFlag = true
        })
    },
    sensitiveShot({commit, shots}, params) {
        return Api.sensitiveShot(params).then(({data}) => {
            let {items, pageNo, pageTotal, totalCount} = data
            state.shots = items
            state.shotPageNo = pageNo
            state.shotTotal = totalCount
            state.shotTotalPage = pageTotal
        })
    },
    delSensitiveShot({commit, shots}, params) {
        return Api.delSensitiveShot(params)
    },
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/components/sensitive_store.js